const comments = [
  {
    name: '影视爱好者小陈',
    text: '用了好几个视频网站，91麻豆的画质确实让人满意，1080P超清在线观看完全不卡，国产高清视频资源也很全，基本想看的都能找到，每天都会来看看更新。',
    time: '2天前',
    tag: '画质好评',
  },
  {
    name: '追剧达人阿明',
    text: '最大的感受就是流畅！以前用别的平台总是缓冲卡顿，这里91高清视频在线播放体验真的好太多了。移动端看也很方便，通勤路上就能追完一部。',
    time: '3天前',
    tag: '流畅体验',
  },
  {
    name: '视频发烧友Jessica',
    text: '资源丰富度超出预期，91国产高清视频分类做得特别细致，找片效率很高。每日更新也很准时，基本上每天都有新内容可以看，非常推荐给喜欢看视频的朋友。',
    time: '5天前',
    tag: '资源丰富',
  },
  {
    name: '日常观影用户老李',
    text: '不用注册就能直接看这点太方便了，操作简单没有门槛。高清影视在线画质清晰，播放稳定几乎没有遇到过卡顿的情况，已经推荐给身边很多朋友使用了。',
    time: '1周前',
    tag: '便捷体验',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            用户评价
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            来自真实用户的观影反馈，您的满意是我们不断进步的动力
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {comments.map((comment, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5 hover:border-primary-200/50 transition-colors cursor-pointer"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-600 font-heading font-bold text-sm">
                    {comment.name.charAt(0)}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-foreground-900 truncate">
                    {comment.name}
                  </div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
                <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full flex-shrink-0 whitespace-nowrap">
                  {comment.tag}
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.text}
              </p>
              <div className="flex items-center gap-1 mt-3 text-accent-500">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}